// Maps backend Spanish content (program events & surprises) to Catalan.
// Backend stores titles/descriptions in Spanish only; this dictionary lets the
// UI translate them on the fly when the user switches to CA.

const PROGRAM_CA = {
  // titles
  "Salida del bus desde Hotel Domo": "Sortida del bus des de l'Hotel Domo",
  "Llegada y bienvenida": "Arribada i benvinguda",
  "¡Sí, quiero!": "Sí, vull!",
  "Cóctel": "Còctel",
  "Convite": "Convit",
  "Fiesta": "Festa",
  "Bus de vuelta": "Bus de tornada",
  // descriptions
  "Vilafranca del Penedès. Recogida de invitados rumbo al Mirador de les Caves.":
    "Vilafranca del Penedès. Recollida d'invitats cap al Mirador de les Caves.",
  "Os recibimos en el Mirador de les Caves.": "Us rebem al Mirador de les Caves.",
  "Ceremonia entre viñedos.": "Cerimònia entre vinyes.",
  "13 aperitivos y 4 paraditas.": "13 aperitius i 4 paradetes.",
  "Un plato principal y postre.": "Un plat principal i postres.",
  "A bailar hasta la madrugada.": "A ballar fins a la matinada.",
  "Regreso al Hotel Domo de Vilafranca.": "Tornada a l'Hotel Domo de Vilafranca.",
};

const SURPRISES_CA = {
  // titles
  "Ventiladores": "Ventalls",
  "Mural de fotos en la bienvenida": "Mural de fotos a la benvinguda",
  "Bolas de la suerte": "Boles de la sort",
  "Entrada especial al aperitivo": "Entrada especial a l'aperitiu",
  "Tattoos": "Tatuatges",
  "Vídeo 360º en el aperitivo": "Vídeo 360º a l'aperitiu",
  "Zona infantil": "Zona infantil",
  "Detalles para vosotros": "Detalls per a vosaltres",
  "Cartas personalizadas": "Cartes personalitzades",
  "Baile nupcial": "Ball nupcial",
  "Rosas con dedicatoria": "Roses amb dedicatòria",
  "Fotomatón": "Fotomaton",
  "Pastel de novios": "Pastís de noces",
  "Hora loca": "Hora boja",
  // descriptions
  "Para refrescarse durante la ceremonia al aire libre. Quedan preciosos para las fotos.":
    "Per refrescar-vos durant la cerimònia a l'aire lliure. Queden preciosos per a les fotos.",
  "Un rincón con recuerdos de nuestra historia juntos para que lo descubráis al llegar.":
    "Un racó amb records de la nostra història junts perquè el descobriu en arribar.",
  "Un pequeño detalle en la bienvenida que os dará suerte durante toda la noche.":
    "Un petit detall a la benvinguda que us donarà sort durant tota la nit.",
  "Una pirotecnia muy especial marcará nuestra entrada al cóctel. Tened el móvil preparado.":
    "Una pirotècnia molt especial marcarà la nostra entrada al còctel. Tingueu el mòbil preparat.",
  "Tatuajes temporales para personalizar el outfit del cóctel. ¡Animaos a llevar el vuestro!":
    "Tatuatges temporals per personalitzar l'outfit del còctel. Animeu-vos a portar el vostre!",
  "Una cámara 360º para que dejéis vuestro mejor vídeo del día. ¡Sorprendednos!":
    "Una càmera 360º perquè ens deixeu el vostre millor vídeo del dia. Sorpreneu-nos!",
  "Desde el cóctel y durante toda la boda, los más peques estarán cuidados con actividades pensadas para ellos.":
    "Des del còctel i durant tota la boda, els més petits estaran cuidats amb activitats pensades per a ells.",
  "Tote bag, taza y un detalle personal con vuestra dedicatoria, que descubriréis en el convite.":
    "Tote bag, tassa i un detall personal amb la vostra dedicatòria, que descobrireu al convit.",
  "Hojas A5 con vuestra cara en acuarela y un mensaje escrito a mano por detrás. Una por cada invitado.":
    "Fulls A5 amb la vostra cara en aquarel·la i un missatge escrit a mà pel darrere. Un per cada convidat.",
  "Nuestro primer baile como pareja casada. Llevamos meses preparándolo, esperamos que os guste.":
    "El nostre primer ball com a parella casada. Fa mesos que ho preparem, esperem que us agradi.",
  "Repartiremos rosas con un mensaje a las personas más importantes para nosotros.":
    "Repartirem roses amb un missatge a les persones més importants per a nosaltres.",
  "Photocall divertido con atrezzo para que os llevéis un recuerdo de la noche.":
    "Photocall divertit amb attrezzo perquè us emporteu un record de la nit.",
  "Cortaremos el pastel y brindaremos con vosotros.":
    "Tallarem el pastís i brindarem amb vosaltres.",
  "Pelucas, gafas, sombreros y mucho ritmo. La pista no parará.":
    "Perruques, ulleres, barrets i molt de ritme. La pista no s'aturarà.",
  // hints (locked descriptions)
  "Algo refrescante os espera en la ceremonia…": "Alguna cosa refrescant us espera a la cerimònia…",
  "Algo lleno de recuerdos os espera al entrar…": "Alguna cosa plena de records us espera en entrar…",
  "La suerte os encontrará a la llegada…": "La sort us trobarà a l'arribada…",
  "Algo brillante marcará nuestra llegada al cóctel…": "Alguna cosa brillant marcarà la nostra arribada al còctel…",
  "Algo divertido para vuestra piel os espera en el cóctel…": "Alguna cosa divertida per a la vostra pell us espera al còctel…",
  "Algo divertido os espera durante el cóctel…": "Alguna cosa divertida us espera durant el còctel…",
  "Los peques tendrán su propio rincón…": "Els petits tindran el seu propi racó…",
  "Un regalo muy nuestro os espera en el convite…": "Un regal molt nostre us espera al convit…",
  "Una carta hecha a mano os espera en el convite…": "Una carta feta a mà us espera al convit…",
  "Llevamos meses preparando algo especial para vosotros…": "Fa mesos que preparem alguna cosa especial per a vosaltres…",
  "Una flor con vuestro nombre os encontrará…": "Una flor amb el vostre nom us trobarà…",
  "Un photocall os espera durante la fiesta…": "Un photocall us espera durant la festa…",
  "Un momento muy dulce que viviremos juntos…": "Un moment molt dolç que viurem junts…",
  "Cuando la pista se descontrole, sabréis lo que es…": "Quan la pista s'enbogeixi, sabreu què és…",
};

const VENUE_CA = {
  "Ctra. d'Ordal a Sant Sadurní Km.3.800, Els Casots, 08739 Subirats, Barcelona":
    "Ctra. d'Ordal a Sant Sadurní Km.3.800, Els Casots, 08739 Subirats, Barcelona",
  "Hotel Domo, Vilafranca del Penedès, Barcelona":
    "Hotel Domo, Vilafranca del Penedès, Barcelona",
};

const DICTS = {
  program: PROGRAM_CA,
  surprise: SURPRISES_CA,
  venue: VENUE_CA,
};

/**
 * Translate a piece of backend text from ES → CA when lang === "ca".
 * Falls back to the original text if no mapping exists.
 * @param {string} text - the original (Spanish) text
 * @param {string} lang - current language ("es" | "ca")
 * @param {keyof typeof DICTS} dict - which dictionary to look in
 */
export function tContent(text, lang, dict = "program") {
  if (!text || lang !== "ca") return text || "";
  const map = DICTS[dict];
  return (map && map[text]) || text;
}
